import { AuthService } from '../../services/auth.service';
import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef, ViewChildren, OnChanges, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { SettingsService } from '../../services/settings.service';
import { GPT_FEATURE, hasFeatureFlag } from '../../utilities/featureFlags';
import { getSideBarMenu } from './menu-items';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
})
export class SidebarComponent implements OnInit, OnChanges {

  showMenu = '';
  index = '';
  showSubMenu = '';
  showSubSubMenu = '';
  subIndex = '';
  initActionChat = false;
  botTestDropped = false;

  public sidebarnavItems: any[];
  public path = '';
  public techTypes = []
  public techSelected = { value: 0, name: 'Default', class: 'tech-active-default' };
  private settings;

  @Input()
  showMiniSidebar: any;
  @Output()
  toggleChatBot: any = new EventEmitter();


  constructor(
    public auth: AuthService,
    public router: Router,
    private settingsService: SettingsService
  ) { }

  ngOnInit() {
    this.setTechTypes();
    this.path = this.router.url.split('admin')[1];
    this.getTechSandbox();
  }

  async setTechTypes(){
    const featureFlags = await this.auth.getFeatureFlags()
    //techtypes
    this.techTypes=[{ value: 1, name: 'shared.headerNavigation.testBot.technology_df', class: 'tech-active-df' }]
    if(hasFeatureFlag(GPT_FEATURE, featureFlags)){
      this.techTypes=this.techTypes.concat([
        { value: 2, name: 'shared.headerNavigation.testBot.technology_gpt', class: 'tech-active-gpt' },
        { value: 3, name: 'shared.headerNavigation.testBot.technology_hybrid', class: 'tech-active-hybrid' }
      ])
    }
    //sidebar
    this.sidebarnavItems = getSideBarMenu(featureFlags).filter(sidebarnavItem => sidebarnavItem);
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.getTechSandbox();
    if (this.showMiniSidebar) { }
  }

  private getTechSandbox(): void {
    this.settingsService.getBotSettings()
      .subscribe((res: any) => {
        this.settings = res;
        if (res.sandboxTechnologyType) {
          const testTechType = res.sandboxTechnologyType;
          this.techSelected = this.techTypes.find(tech => tech.value === testTechType);
        }
      });
  }

  toggleDrop(event) {
    this.botTestDropped = event;
  }

  //[first level] This is to control opening and closing submenus
  addExpandClass(element: any, index: any) {
    this.index = index;
    if (element === this.showMenu && this.index === index) {
      this.showMenu = '0';
      this.index = '0';
    } else {
      this.showMenu = element;
    }
  }

  //[Second level] This is to control opening and closing submenus
  addActiveClass(element: any, index: any) {
    if (element === this.showSubSubMenu && element === this.showSubMenu) {
      this.showSubSubMenu = '0';
      this.showSubMenu = '0';
      this.subIndex = '0';
    }
    else {
      this.showSubMenu = element;
      this.showSubSubMenu = element;
      this.subIndex = index;
    }
  }

  public validateButtonClass(tech: { value: number, name: string, class: string }): string {
    if (this.initActionChat && this.techSelected.value === tech.value) return tech.class;
    return '';
  }

  public toggleChat(tech: number): void {
    this.botTestDropped = false;
    if (this.techSelected.value !== tech) {
      this.updateSanboxTech(tech);
      this.techSelected = this.techTypes.find(techType => techType.value === tech);
      this.initActionChat = false;
      this.toggleChatBot.emit(this.initActionChat);
      setTimeout(() => {
        this.initActionChat = true;
        this.toggleChatBot.emit(this.initActionChat);
      }, 500);
      return
    }
    this.initActionChat = !this.initActionChat;
    this.toggleChatBot.emit(this.initActionChat);
  }

  private updateSanboxTech(tech: number) {
    if (this.settings) {
      this.settingsService.updateBotSettings({ ...this.settings, sandboxTechnologyType: tech })
        .subscribe((res: any) => { });
      return;
    }
  }

}
